import {Cookies} from 'react-cookie';
import {
    ADMIN_RESET,
    ADMINS_RESET,
    ADMINS_PENDING,
    ADMINS_DOWNLOADED,
    ADMIN_FOCUS,
    ADMIN_DOWNLOADED,
    ADMINS_FAILED,
    ADMIN_FAILED,
    ADMIN_CONFLICT,
    ADMIN_POSTING,
    ADMIN_EDITING,
    ADMIN_DELETING
} from './types';
import APIService from '../../services/api'
import {handleError} from '../infos/actions'

const cookies = new Cookies();

// Action creators

export const adminsPendingAction = () => {
    return {
        type: ADMINS_PENDING
    }
};

export const adminResetAction = () => {
    return {
        type: ADMIN_RESET
    }
};

export const adminsResetAction = () => {
    return {
        type: ADMINS_RESET
    }
};

export const adminEditAction = () => {
    return {
        type: ADMIN_EDITING
    }
};

export const adminDeleteAction = () => {
    return {
        type: ADMIN_DELETING
    }
};

export const adminPostingAction = () => {
    return {
        type: ADMIN_POSTING
    }
};

export const adminsDownloadedAction = (admins) => {
    return {
        type: ADMINS_DOWNLOADED,
        payload: admins
    }
};

export const adminDownloadedAction = (admin) => {
    return {
        type: ADMIN_DOWNLOADED,
        payload: admin
    }
};

export const adminFocusAction = (admin) => {
    return {
        type: ADMIN_FOCUS,
        payload: admin
    }
};

// Actions

export function resetAdmin() {
    return function (dispatch) {
        dispatch(adminResetAction());
    }
}

export function getAdmins() {
    return function (dispatch) {
        dispatch(adminsPendingAction());
        return APIService
            .getAdmins(cookies.get('token'))
            .then(superadmins => {
                dispatch(adminsDownloadedAction(superadmins));
            })
            .catch((error) => {
                dispatch(handleError(error, ADMINS_FAILED))
            });
    }
}

export function fetchAdmin(id) {
    return function (dispatch, getState) {
        let admins = getState().admins.content;
        let admin = admins.find(function (admin) {
            return admin.id === id
        });

        if (admin) {
            return dispatch(adminFocusAction(admin));
        } else {
            return dispatch(getAdmin(id));
        }
    }
}

export function getAdmin(id) {
    return function (dispatch) {
        dispatch(adminsPendingAction());
        return APIService
            .getAdmin(id, cookies.get('token'))
            .then(admin => {
                dispatch(adminDownloadedAction(admin));
            })
            .catch((error) => {
                dispatch(handleError(error, ADMIN_FAILED))
            });
    }
}

export function postAdmin(admin) {
    return function (dispatch) {
        dispatch(adminPostingAction());
        return APIService
            .addAdmin(admin, cookies.get('token'))
            .then(admin => {
                dispatch(adminDownloadedAction(admin));
            })
            .catch((error) => {
                dispatch(handleError(error, ADMIN_FAILED))
            });
    }
}

export function deleteAdmin(admin) {
    return function (dispatch) {
        dispatch(adminDeleteAction());
        return APIService
            .deleteAdmin(admin, cookies.get('token'))
            .then(() => {
                dispatch(adminResetAction());
            })
            .catch((error) => {
                dispatch(handleError(error, ADMIN_FAILED))
            });
    }
}

export function putAdmin(admin) {
    return function (dispatch) {
        dispatch(adminEditAction());
        return APIService
            .editAdmin(admin, cookies.get('token'))
            .then(admin => {
                dispatch(adminDownloadedAction(admin));
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 409) {
                        dispatch(handleError(error, ADMIN_CONFLICT))
                    } else {
                        dispatch(handleError(error, ADMIN_FAILED))
                    }
                } else {
                    dispatch(handleError(error, ADMIN_FAILED))
                }
            });
    }
}



// WEBPACK FOOTER //
// src/store/admins/actions.js